.staticLoaderSliding {
  overflow: visible;
}